import { useState } from "react";
import { useSelector } from "react-redux";
import { Button, Col, Modal, ModalBody } from "reactstrap";
import { CategoryDto } from "../../../models/categoryDto";

import hasRoles from "../../../security/hasRoles";
import keycloak from "../../../security/keycloak-config";
import { RootState } from "../../../store";
import AddImagesGallery from "../../Support/add-images-gallery/addImagesGallery";
import AddSupport from "../../Support/add-support/addSupport";
import AddVideo from "../../Support/add-video/addVideo";
import styles from "./categoryCard.module.scss";
import { translate } from "react-switch-lang";
import AddFolderThematic from "../../thematic-folder/add-folder-thematic/addFolderThematic";

const CategoryCard: React.FC<{
  t: (key: string) => {};
  data: CategoryDto;
  handleClickCategory: (data: CategoryDto) => void;
  editCategory: (data: CategoryDto) => void;
  removeCategory: (categoryId: number) => void;
}> = ({ data, handleClickCategory, editCategory, removeCategory, t }) => {
  const hasRoleAdmin = hasRoles(["ROLE_MEDIATHEQUE_ADMIN"], keycloak);
  const selectedLanguage = useSelector((state: RootState) => state.language.currentLang);
  const [category, setCatgeory] = useState<CategoryDto>(new CategoryDto());
  const [openModal, setOpenModal] = useState<boolean>(false);
  const handleClickAddMedia = (data: CategoryDto) => {
    setCatgeory(data);
    setOpenModal(!openModal);
  };

  return (
    <>
      <Col sm="12" md="6" xl="6" className={""}>
        <div className={styles["category-card-container"]}>
          <div className={styles["category-image-wrapper"]}>
            <img className={styles["category-image"]} src={data.urlImage} alt="" onClick={() => handleClickCategory(data)} />
          </div>

          <div className={styles["category-details"]}>
            <div className={styles["category-title-wrapper"]} onClick={() => handleClickCategory(data)}>
              {selectedLanguage === "en" ? <h3 className={styles["category-title"]}>{data.titleAnglais}</h3> : <h3 className={styles["category-title"]}>{data.titleFrancais}</h3>}
            </div>

            <div className={styles["category-card__actions"]}>
              {!hasRoleAdmin && (
                <Button
                  className={hasRoleAdmin ? styles["category-card__actions__btn-more_admin"] : styles["category-card__actions__btn-more"]}
                  outline
                  color="light"
                  onClick={() => handleClickCategory(data)}
                >
                  {t("button_show_more")}
                </Button>
              )}
              {hasRoleAdmin && (
                <>
                  <Button className={styles["category-card__actions__btn-more_admin"]} outline color="light" onClick={() => handleClickAddMedia(data)}>
                    {+data.typeCategory === 0 ? (
                      <> {t("button_add_pdf")} </>
                    ) : +data.typeCategory === 1 ? (
                      <>{t("button_add_video")}</>
                    ) : +data.typeCategory === 2 ? (
                      <>{t("button_add_expo")}</>
                    ) : (
                      <>{t("button_add_folder")}</>
                    )}
                  </Button>
                  <div>
                    <i className={`${styles["category-actions__btn-update"]} fa fa-edit`} onClick={() => editCategory(data)}></i>
                    <i className={`${styles["category-actions__btn-delete"]} fa fa-trash-o`} onClick={() => removeCategory(data.categoryId)}></i>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </Col>
      <Modal isOpen={openModal} size="lg">
        <ModalBody className={styles["modal-body"]}>
          <div>
            <h6 className={styles["title-model"] + " p-20"}>
              {+category?.typeCategory === 0
                ? t("title_add_document")
                : +category?.typeCategory === 1
                ? t("title_add_video")
                : +category?.typeCategory === 2
                ? t("title_add_exhibit")
                : t("title_add_folder")}
            </h6>
          </div>
          {+category?.typeCategory === 0 ? (
            <AddSupport
              type={category?.typeCategory}
              getListSupport={() => {
                ("");
              }}
              resetAllFieldSearch={() => {}}
              closeToggle={handleClickAddMedia}
              categoryId={category?.categoryId}
              path={category?.titleAnglais}
            />
          ) : +category?.typeCategory === 1 ? (
            <AddVideo
              getListSupport={() => {
                ("");
              }}
              resetAllFieldSearch={() => {}}
              categoryId={category?.categoryId}
              support={null}
              closeToggle={handleClickAddMedia}
              path={category?.titleAnglais}
            ></AddVideo>
          ) : +category?.typeCategory === 2 ? (
            <AddImagesGallery
              handlerListener={() => {
                ("");
              }}
              resetAllFieldSearch={() => {}}
              closeToggle={handleClickAddMedia}
              categoryId={category?.categoryId}
              path={category?.titleAnglais}
            ></AddImagesGallery>
          ) : (
            <AddFolderThematic
              isShowDropZone={true}
              setIsShowDropZone={() => {}}
              modal={openModal}
              isOnCreate={true}
              formValidation={false}
              toggle={() => handleClickAddMedia(new CategoryDto())}
              parentId={0}
              handleGetListFolderThematic={() => {}}
              categoryId={category?.categoryId}
              editFolderData={null}
            ></AddFolderThematic>
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default translate(CategoryCard);
